import { Component } from '@angular/core';

@Component({
  selector: 'app-pen-icon',
  standalone: true,
  templateUrl: './pen-icon.component.html',
})
export class PenIconComponent {}
